import { useRef } from 'react';

import Heading from 'components/heading/Heading';
import AutoGrid from 'components/auto-grid/AutoGrid';
import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';

import ProcessItem from './ProcessItem';
import ProcessCarousel from './ProcessCarousel';

import { IProcess } from 'source/NFR.types';

const Process: React.FC<IProcess> = ({ title, introText, isCarousel, items = [], labels }) => {
  const processRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div className="process" ref={processRef}>
        {title && <Heading className="process--title">{title}</Heading>}
        {introText && <p>{introText}</p>}
        {items.length > 0 &&
          (isCarousel ? (
            <ProcessCarousel items={items} labels={labels} />
          ) : (
            <AutoGrid className="process--items">
              {AutoGridItem =>
                items?.map((item, index) => (
                  <AutoGridItem key={item.title || item.text || index}>
                    <ProcessItem key={item.text} {...item} index={index} />
                  </AutoGridItem>
                ))
              }
            </AutoGrid>
          ))}
      </div>
      {items.length > 0 && (
        <div className="process-print">
          {items?.map(({ title, text, icon }, index) => (
            <div className="process-print--item" key={title || text || index}>
              {icon ? (
                <Image {...icon} {...imageSizes.icon.large} />
              ) : (
                <Heading className="process-item--number" level={2}>
                  {index + 1}
                </Heading>
              )}
              <Heading className="process-item--title">{title}</Heading>
              <p>{text}</p>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

Process.displayName = 'Process';

export default Process;
